export const tr = {
    'audio-title': 'Ses kayıtların arşivi'
};
